export const COLLECTION_NAME = 'users';

export { addToCollection, removeFromCollection } from './addToCollection';
export { createCustomer } from './createCustomer';
export { moveToArchive, unarchiveStory } from './moveToArchive';
export { registerUser } from './registerUser';
export { updateUser, existsHandle, updateHandle } from './updateUser';
export { useToggleFavorite } from './toggleFavorite';
export { removeLogs } from './removeLogs';
export { matchReferrals } from './matchReferrals';
export { updateReferrals } from './updateReferrals';
export { useStandalone } from './registerDevice';
